import React, { useContext } from "react";
import { ProjectContext } from "./context";
import { Error, Loading } from "./states";
import WeeklyStats from "./WeeklyStats";
import YearlyStats from "./YearlyStats";

import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  Colors,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  Colors,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
);

const ProjectDataRoot = () => {
  const { error, loading, projectData } = useContext(ProjectContext);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error message={error.message} />;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="project__widget-container">
            {projectData.weekly ? (
              <>
                <WeeklyStats
                  wind_river={projectData.wind_river}
                  data={projectData.weekly}
                  stats={projectData.weekly_stats || null}
                  title={projectData.weekly_title}
                />
                <hr />
              </>
            ) : null}
            {projectData.yearly ? (
              <YearlyStats
                id={projectData.project_id}
                title={projectData.title}
                data={projectData.yearly}
                info_boxes={projectData.info_boxes || null}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDataRoot;
